module.exports = __webpack_public_path__ + "img/semi-circle.1096e711.png";